import { optionsForMarket, type SingleQuestionDefinition } from "@ferrivia/api-contract";
import { useMarket } from "@ferrivia/i18n";
import { RadioChip } from "@ferrivia/ui";
import s from "./ChoiceGroup.module.css";

export interface SingleChoiceQuestionProps {
  question: SingleQuestionDefinition;
  labelledBy: string;
  value: string | undefined;
  onChange: (optionId: string) => void;
  optionLabelFor: (optionId: string) => string;
}

export function SingleChoiceQuestion({ question, labelledBy, value, onChange, optionLabelFor }: SingleChoiceQuestionProps) {
  const options = optionsForMarket(question.options ?? [], useMarket());

  return (
    <div role="radiogroup" aria-labelledby={labelledBy} className={s.chips}>
      {options.map((option) => (
        <RadioChip
          key={option.id}
          name={question.key}
          className={s.chip}
          checked={value === option.id}
          onChange={() => onChange(option.id)}
        >
          {optionLabelFor(option.id)}
        </RadioChip>
      ))}
    </div>
  );
}
